import { EquipmentType } from "../../models/equipment-type.enum";
import { Equipment, Tier } from "../../models/item-data-models";

export const equipmentData: Equipment[] = [
  // Favourite Gear - Regular
  {
    equipmentType: EquipmentType.MyGearRegularNormal,
    selection: 'my',
    slot: 'gear',
    displayName: 'Regular, Normal',
    category: 'regular',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-my-regular-normal',
  },
  {
    equipmentType: EquipmentType.MyGearRegularMagic,
    selection: 'my',
    slot: 'gear',
    displayName: 'Regular, Magic',
    category: 'regular',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-my-regular-magic',
  },
  {
    equipmentType: EquipmentType.MyGearRegularRare,
    selection: 'my',
    slot: 'gear',
    displayName: 'Regular, Rare',
    category: 'regular',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-my-regular-rare',
  },

  // Favourite Gear - Rare
  {
    equipmentType: EquipmentType.MyGearRareT5,
    selection: 'my',
    slot: 'gear',
    displayName: 'Rare, T5',
    category: 'rare',
    tieredTier: Tier.BOrange,
    subtleTier: Tier.BOrange,
    ruleId: 'gear-my-rare-t5',
  },
  {
    equipmentType: EquipmentType.MyGearRareT4,
    selection: 'my',
    slot: 'gear',
    displayName: 'Rare, T4',
    category: 'rare',
    tieredTier: Tier.BOrange,
    subtleTier: Tier.CYellow,
    ruleId: 'gear-my-rare-t4',
  },
  {
    equipmentType: EquipmentType.MyGearRareT3,
    selection: 'my',
    slot: 'gear',
    displayName: 'Rare, T3',
    category: 'rare',
    tieredTier: Tier.CYellow,
    subtleTier: Tier.CYellow,
    ruleId: 'gear-my-rare-t3',
  },
  {
    equipmentType: EquipmentType.MyGearRareT2,
    selection: 'my',
    slot: 'gear',
    displayName: 'Rare, T2',
    category: 'rare',
    tieredTier: Tier.DWhite,
    subtleTier: Tier.CYellow,
    ruleId: 'gear-my-rare-t2',
  },

  // Favourite Gear - Magic
  {
    equipmentType: EquipmentType.MyGearMagicT5,
    selection: 'my',
    slot: 'gear',
    displayName: 'Magic, T5',
    category: 'magic',
    tieredTier: Tier.ARed,
    subtleTier: Tier.ARed,
    ruleId: 'gear-my-magic-t5',
  },
  {
    equipmentType: EquipmentType.MyGearMagicT4,
    selection: 'my',
    slot: 'gear',
    displayName: 'Magic, T4',
    category: 'magic',
    tieredTier: Tier.BOrange,
    subtleTier: Tier.ARed,
    ruleId: 'gear-my-magic-t4',
  },
  {
    equipmentType: EquipmentType.MyGearMagicT3,
    selection: 'my',
    slot: 'gear',
    displayName: 'Magic, T3',
    category: 'magic',
    tieredTier: Tier.CYellow,
    subtleTier: Tier.CYellow,
    ruleId: 'gear-my-magic-t3',
  },
  {
    equipmentType: EquipmentType.MyGearMagicT2,
    selection: 'my',
    slot: 'gear',
    displayName: 'Magic, T2',
    category: 'magic',
    tieredTier: Tier.DWhite,
    subtleTier: Tier.CYellow,
    ruleId: 'gear-my-magic-t2',
  },

  // Favourite Gear - Exceptional
  {
    equipmentType: EquipmentType.MyGearExcellentExceptional,
    selection: 'my',
    slot: 'gear',
    displayName: 'Excellent Exceptional',
    category: 'crafting',
    tieredTier: Tier.SPurple,
    subtleTier: Tier.SPurple,
    ruleId: 'gear-my-excellent-exceptional',
  },
  {
    equipmentType: EquipmentType.MyGearGoodExceptional,
    selection: 'my',
    slot: 'gear',
    displayName: 'Good Exceptional',
    category: 'crafting',
    tieredTier: Tier.ARed,
    subtleTier: Tier.DWhite,
    ruleId: 'gear-my-good-exceptional',
  },

  // Favourite Gear - iLevel
  {
    equipmentType: EquipmentType.MyGearExcellentILevel,
    selection: 'my',
    slot: 'gear',
    displayName: 'Excellent iLevel',
    category: 'crafting',
    tieredTier: Tier.DWhite,
    subtleTier: Tier.DWhite,
    ruleId: 'gear-my-excellent-ilevel',
  },
  {
    equipmentType: EquipmentType.MyGearGoodILevel,
    selection: 'my',
    slot: 'gear',
    displayName: 'Good iLevel',
    category: 'crafting',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-my-good-ilevel',
  },

  // Favourite Gear - Low Tier Rare
  {
    equipmentType: EquipmentType.MyGearLowerGearTierRareT5,
    selection: 'my',
    slot: 'gear',
    displayName: 'Low Tier, Rare, T5',
    category: 'rare',
    tieredTier: Tier.CYellow,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-my-lower-tier-rare-t5',
  },
  {
    equipmentType: EquipmentType.MyGearLowerGearTierRareT4,
    selection: 'my',
    slot: 'gear',
    displayName: 'Low Tier, Rare, T4',
    category: 'rare',
    tieredTier: Tier.DWhite,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-my-lower-tier-rare-t4',
  },
  {
    equipmentType: EquipmentType.MyGearLowerGearTierRareT3,
    selection: 'my',
    slot: 'gear',
    displayName: 'Low Tier, Rare, T3',
    category: 'rare',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-my-lower-tier-rare-t3',
  },

  // Favourite Gear - Low Tier Magic
  {
    equipmentType: EquipmentType.MyGearLowerGearTierMagicT5,
    selection: 'my',
    slot: 'gear',
    displayName: 'Low Tier, Magic, T5',
    category: 'magic',
    tieredTier: Tier.CYellow,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-my-lower-tier-magic-t5',
  },
  {
    equipmentType: EquipmentType.MyGearLowerGearTierMagicT4,
    selection: 'my',
    slot: 'gear',
    displayName: 'Low Tier, Magic, T4',
    category: 'magic',
    tieredTier: Tier.DWhite,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-my-lower-tier-magic-t4',
  },
  {
    equipmentType: EquipmentType.MyGearLowerGearTierMagicT3,
    selection: 'my',
    slot: 'gear',
    displayName: 'Low Tier, Magic, T3',
    category: 'magic',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-my-lower-tier-magic-t3',
  },

  // Other Gear - Rare
  {
    equipmentType: EquipmentType.OtherGearRareT5,
    selection: 'other',
    slot: 'gear',
    displayName: 'Rare, T5',
    category: 'rare',
    tieredTier: Tier.BOrange,
    subtleTier: Tier.CYellow,
    ruleId: 'gear-unidentified-tier-rare-t5',
  },
  {
    equipmentType: EquipmentType.OtherGearRareT4,
    selection: 'other',
    slot: 'gear',
    displayName: 'Rare, T4',
    category: 'rare',
    tieredTier: Tier.CYellow,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-unidentified-tier-rare-t4',
  },
  {
    equipmentType: EquipmentType.OtherGearRareT3,
    selection: 'other',
    slot: 'gear',
    displayName: 'Rare, T3',
    category: 'rare',
    tieredTier: Tier.DWhite,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-unidentified-tier-rare-t3',
  },
  {
    equipmentType: EquipmentType.OtherGearRareT2,
    selection: 'other',
    slot: 'gear',
    displayName: 'Rare, T2',
    category: 'rare',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-unidentified-tier-rare-t2',
  },

  // Other Gear - Magic
  {
    equipmentType: EquipmentType.OtherGearMagicT5,
    selection: 'other',
    slot: 'gear',
    displayName: 'Magic, T5',
    category: 'magic',
    tieredTier: Tier.BOrange,
    subtleTier: Tier.BOrange,
    ruleId: 'gear-unidentified-tier-magic-t5',
  },
  {
    equipmentType: EquipmentType.OtherGearMagicT4,
    selection: 'other',
    slot: 'gear',
    displayName: 'Magic, T4',
    category: 'magic',
    tieredTier: Tier.CYellow,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-unidentified-tier-magic-t4',
  },
  {
    equipmentType: EquipmentType.OtherGearMagicT3,
    selection: 'other',
    slot: 'gear',
    displayName: 'Magic, T3',
    category: 'magic',
    tieredTier: Tier.DWhite,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-unidentified-tier-magic-t3',
  },
  {
    equipmentType: EquipmentType.OtherGearMagicT2,
    selection: 'other',
    slot: 'gear',
    displayName: 'Magic, T2',
    category: 'magic',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-unidentified-tier-magic-t2',
  },

  // Other Gear - Exceptional
  {
    equipmentType: EquipmentType.OtherGearExcellentExceptionalSocketed,
    selection: 'other',
    slot: 'gear',
    displayName: 'Excellent Exceptional Socketed',
    category: 'crafting',
    tieredTier: Tier.ARed,
    subtleTier: Tier.ARed,
    ruleId: 'gear-exceptional-excellent-socketed',
  },
  {
    equipmentType: EquipmentType.OtherGearGoodExceptionalSocketed,
    selection: 'other',
    slot: 'gear',
    displayName: 'Good Exceptional Socketed',
    category: 'crafting',
    tieredTier: Tier.BOrange,
    subtleTier: Tier.DWhite,
    ruleId: 'gear-exceptional-good-socketed',
  },
  {
    equipmentType: EquipmentType.OtherGearExcellentExceptionalQuality,
    selection: 'other',
    slot: 'gear',
    displayName: 'Excellent Exceptional Quality',
    category: 'crafting',
    tieredTier: Tier.ARed,
    subtleTier: Tier.ARed,
    ruleId: 'gear-exceptional-excellent-quality',
  },
  {
    equipmentType: EquipmentType.OtherGearGoodExceptionalQuality,
    selection: 'other',
    slot: 'gear',
    displayName: 'Good Exceptional Quality',
    category: 'crafting',
    tieredTier: Tier.BOrange,
    subtleTier: Tier.DWhite,
    ruleId: 'gear-exceptional-good-quality',
  },

  // Other Gear - iLevel
  {
    equipmentType: EquipmentType.OtherGearILevel82,
    selection: 'other',
    slot: 'gear',
    displayName: 'iLevel 82+',
    category: 'crafting',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-crafting-bases-ilevel-82',
  },
  {
    equipmentType: EquipmentType.OtherGearILevel81,
    selection: 'other',
    slot: 'gear',
    displayName: 'iLevel 81',
    category: 'crafting',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-crafting-bases-ilevel-81',
  },
  {
    equipmentType: EquipmentType.OtherGearSpecialGear,
    selection: 'other',
    slot: 'gear',
    displayName: 'Special Gear',
    category: 'other',
    tieredTier: Tier.ARed,
    subtleTier: Tier.ARed,
    ruleId: 'gear-special-gear',
  },

  // Other Gear - Low Tier Rare
  {
    equipmentType: EquipmentType.OtherGearLowerGearTierRareT5,
    selection: 'other',
    slot: 'gear',
    displayName: 'Low Tier, Rare, T5',
    category: 'rare',
    tieredTier: Tier.CYellow,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-unidentified-tier-low-tier-rare-t5',
  },
  {
    equipmentType: EquipmentType.OtherGearLowerGearTierRareT4,
    selection: 'other',
    slot: 'gear',
    displayName: 'Low Tier, Rare, T4',
    category: 'rare',
    tieredTier: Tier.DWhite,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-unidentified-tier-low-tier-rare-t4',
  },
  {
    equipmentType: EquipmentType.OtherGearLowerGearTierRareT3,
    selection: 'other',
    slot: 'gear',
    displayName: 'Low Tier, Rare, T3',
    category: 'rare',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-unidentified-tier-low-tier-rare-t3',
  },

  // Other Gear - Low Tier Magic
  {
    equipmentType: EquipmentType.OtherGearLowerGearTierMagicT5,
    selection: 'other',
    slot: 'gear',
    displayName: 'Low Tier, Magic, T5',
    category: 'magic',
    tieredTier: Tier.CYellow,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-unidentified-tier-low-tier-magic-t5',
  },
  {
    equipmentType: EquipmentType.OtherGearLowerGearTierMagicT4,
    selection: 'other',
    slot: 'gear',
    displayName: 'Low Tier, Magic, T4',
    category: 'magic',
    tieredTier: Tier.DWhite,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-unidentified-tier-low-tier-magic-t4',
  },
  {
    equipmentType: EquipmentType.OtherGearLowerGearTierMagicT3,
    selection: 'other',
    slot: 'gear',
    displayName: 'Low Tier, Magic, T3',
    category: 'magic',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-unidentified-tier-low-tier-magic-t3',
  },

  // Other Gear - Identified - All
  {
    equipmentType: EquipmentType.OtherAllIdentifiedItems,
    selection: 'other',
    slot: 'other',
    displayName: 'All Identified Items',
    category: 'identified',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'identified-item-show-all',
  },

  // Other Gear - Identified
  {
    equipmentType: EquipmentType.OtherExcellentIdentifiedGear,
    selection: 'other',
    slot: 'gear',
    displayName: 'Excellent Identified',
    category: 'identified',
    tieredTier: Tier.SPurple,
    subtleTier: Tier.SPurple,
    ruleId: 'gear-identified-excellent',
  },
  {
    equipmentType: EquipmentType.OtherGoodIdentifiedGear,
    selection: 'other',
    slot: 'gear',
    displayName: 'Good Identified',
    category: 'identified',
    tieredTier: Tier.BOrange,
    subtleTier: Tier.BOrange,
    ruleId: 'gear-identified-good',
  },

  // Other Gear - Leveling
  {
    equipmentType: EquipmentType.OtherGearLevelingNormal,
    selection: 'other',
    slot: 'gear',
    displayName: 'Normal',
    category: 'leveling',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-leveling-weapons-normal',
  },
  {
    equipmentType: EquipmentType.OtherGearLevelingMagic,
    selection: 'other',
    slot: 'gear',
    displayName: 'Magic',
    category: 'leveling',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-leveling-weapons-magic',
  },
  {
    equipmentType: EquipmentType.OtherGearLevelingRare,
    selection: 'other',
    slot: 'gear',
    displayName: 'Rare',
    category: 'leveling',
    tieredTier: Tier.CYellow,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-leveling-weapons-rare',
  },
  {
    equipmentType: EquipmentType.OtherGearLevelingRaresStyle,
    selection: 'other',
    slot: 'gear',
    displayName: 'Leveling Rares',
    category: 'leveling',
    tieredTier: Tier.DWhite,
    subtleTier: Tier.DWhite,
    ruleId: 'gear-leveling-rare-first-areas',
  },
  {
    equipmentType: EquipmentType.OtherGearLevelingMagicsStyle,
    selection: 'other',
    slot: 'gear',
    displayName: 'Leveling Magics',
    category: 'leveling',
    tieredTier: Tier.DWhite,
    subtleTier: Tier.DWhite,
    ruleId: 'gear-leveling-magics-style',
  },
  {
    equipmentType: EquipmentType.OtherGearLevelingMagicRareBoots,
    selection: 'other',
    slot: 'gear',
    displayName: 'Magic & Rare Boots',
    category: 'leveling',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-leveling-armour-magic-rare-boots',
  },

  // Other Gear - POE2 - Salvaging
  {
    equipmentType: EquipmentType.OtherGearSalvagingSocketed,
    selection: 'other',
    slot: 'gear',
    displayName: 'Socketed',
    category: 'salvaging',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-salvaging-sockets',
  },
  {
    equipmentType: EquipmentType.OtherGearSalvagingQualityMartialWeapons,
    selection: 'other',
    slot: 'gear',
    displayName: 'Quality Martial Weapons',
    category: 'salvaging',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-salvaging-quality-weapons-martial',
  },
  {
    equipmentType: EquipmentType.OtherGearSalvagingQualityCasterWeapons,
    selection: 'other',
    slot: 'gear',
    displayName: 'Quality Caster Weapons',
    category: 'salvaging',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-salvaging-quality-weapons-caster',
  },
  {
    equipmentType: EquipmentType.OtherGearSalvagingQualityArmour,
    selection: 'other',
    slot: 'gear',
    displayName: 'Quality Armour',
    category: 'salvaging',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'gear-salvaging-quality-armour',
  },

  // Favourite Jewellery - Regular
  {
    equipmentType: EquipmentType.MyJewelleryRegularNormal,
    selection: 'my',
    slot: 'jewellery',
    displayName: 'Regular, Normal',
    category: 'regular',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'jewellery-my-regular-normal',
  },
  {
    equipmentType: EquipmentType.MyJewelleryRegularMagic,
    selection: 'my',
    slot: 'jewellery',
    displayName: 'Regular, Magic',
    category: 'regular',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'jewellery-my-regular-magic',
  },
  {
    equipmentType: EquipmentType.MyJewelleryRegularRare,
    selection: 'my',
    slot: 'jewellery',
    displayName: 'Regular, Rare',
    category: 'regular',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'jewellery-my-regular-rare',
  },

  // Favourite Jewellery - Rare
  {
    equipmentType: EquipmentType.MyJewelleryRareT5,
    selection: 'my',
    slot: 'jewellery',
    displayName: 'Rare, T5',
    category: 'rare',
    tieredTier: Tier.ARed,
    subtleTier: Tier.ARed,
    ruleId: 'jewellery-my-rare-t5',
  },
  {
    equipmentType: EquipmentType.MyJewelleryRareT4,
    selection: 'my',
    slot: 'jewellery',
    displayName: 'Rare, T4',
    category: 'rare',
    tieredTier: Tier.BOrange,
    subtleTier: Tier.ARed,
    ruleId: 'jewellery-my-rare-t4',
  },
  {
    equipmentType: EquipmentType.MyJewelleryRareT3,
    selection: 'my',
    slot: 'jewellery',
    displayName: 'Rare, T3',
    category: 'rare',
    tieredTier: Tier.CYellow,
    subtleTier: Tier.CYellow,
    ruleId: 'jewellery-my-rare-t3',
  },
  {
    equipmentType: EquipmentType.MyJewelleryRareT2,
    selection: 'my',
    slot: 'jewellery',
    displayName: 'Rare, T2',
    category: 'rare',
    tieredTier: Tier.DWhite,
    subtleTier: Tier.CYellow,
    ruleId: 'jewellery-my-rare-t2',
  },

  // Favourite Jewellery - Magic
  {
    equipmentType: EquipmentType.MyJewelleryMagicT5,
    selection: 'my',
    slot: 'jewellery',
    displayName: 'Magic, T5',
    category: 'magic',
    tieredTier: Tier.ARed,
    subtleTier: Tier.ARed,
    ruleId: 'jewellery-my-magic-t5',
  },
  {
    equipmentType: EquipmentType.MyJewelleryMagicT4,
    selection: 'my',
    slot: 'jewellery',
    displayName: 'Magic, T4',
    category: 'magic',
    tieredTier: Tier.BOrange,
    subtleTier: Tier.ARed,
    ruleId: 'jewellery-my-magic-t4',
  },
  {
    equipmentType: EquipmentType.MyJewelleryMagicT3,
    selection: 'my',
    slot: 'jewellery',
    displayName: 'Magic, T3',
    category: 'magic',
    tieredTier: Tier.CYellow,
    subtleTier: Tier.CYellow,
    ruleId: 'jewellery-my-magic-t3',
  },
  {
    equipmentType: EquipmentType.MyJewelleryMagicT2,
    selection: 'my',
    slot: 'jewellery',
    displayName: 'Magic, T2',
    category: 'magic',
    tieredTier: Tier.DWhite,
    subtleTier: Tier.CYellow,
    ruleId: 'jewellery-my-magic-t2',
  },

  // Favourite Jewellery - iLevel
  {
    equipmentType: EquipmentType.MyJewelleryExcellentILevel,
    selection: 'my',
    slot: 'jewellery',
    displayName: 'Excellent iLevel',
    category: 'crafting',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.DWhite,
    ruleId: 'jewellery-my-excellent-ilevel',
  },
  {
    equipmentType: EquipmentType.MyJewelleryGoodILevel,
    selection: 'my',
    slot: 'jewellery',
    displayName: 'Good iLevel',
    category: 'crafting',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'jewellery-my-good-ilevel',
  },

  // Other Jewellery - Rare
  {
    equipmentType: EquipmentType.OtherJewelleryRareT5,
    selection: 'other',
    slot: 'jewellery',
    displayName: 'Rare, T5',
    category: 'rare',
    tieredTier: Tier.BOrange,
    subtleTier: Tier.BOrange,
    ruleId: 'jewellery-unidentified-tier-rare-t5',
  },
  {
    equipmentType: EquipmentType.OtherJewelleryRareT4,
    selection: 'other',
    slot: 'jewellery',
    displayName: 'Rare, T4',
    category: 'rare',
    tieredTier: Tier.CYellow,
    subtleTier: Tier.EVisible,
    ruleId: 'jewellery-unidentified-tier-rare-t4',
  },
  {
    equipmentType: EquipmentType.OtherJewelleryRareT3,
    selection: 'other',
    slot: 'jewellery',
    displayName: 'Rare, T3',
    category: 'rare',
    tieredTier: Tier.DWhite,
    subtleTier: Tier.EVisible,
    ruleId: 'jewellery-unidentified-tier-rare-t3',
  },
  {
    equipmentType: EquipmentType.OtherJewelleryRareT2,
    selection: 'other',
    slot: 'jewellery',
    displayName: 'Rare, T2',
    category: 'rare',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'jewellery-unidentified-tier-rare-t2',
  },

  // Other Jewellery - Magic
  {
    equipmentType: EquipmentType.OtherJewelleryMagicT5,
    selection: 'other',
    slot: 'jewellery',
    displayName: 'Magic, T5',
    category: 'magic',
    tieredTier: Tier.BOrange,
    subtleTier: Tier.BOrange,
    ruleId: 'jewellery-unidentified-tier-magic-t5',
  },
  {
    equipmentType: EquipmentType.OtherJewelleryMagicT4,
    selection: 'other',
    slot: 'jewellery',
    displayName: 'Magic, T4',
    category: 'magic',
    tieredTier: Tier.CYellow,
    subtleTier: Tier.EVisible,
    ruleId: 'jewellery-unidentified-tier-magic-t4',
  },
  {
    equipmentType: EquipmentType.OtherJewelleryMagicT3,
    selection: 'other',
    slot: 'jewellery',
    displayName: 'Magic, T3',
    category: 'magic',
    tieredTier: Tier.DWhite,
    subtleTier: Tier.EVisible,
    ruleId: 'jewellery-unidentified-tier-magic-t3',
  },
  {
    equipmentType: EquipmentType.OtherJewelleryMagicT2,
    selection: 'other',
    slot: 'jewellery',
    displayName: 'Magic, T2',
    category: 'magic',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'jewellery-unidentified-tier-magic-t2',
  },

  // Other Jewellery - Crafting Bases
  {
    equipmentType: EquipmentType.OtherJewelleryExcellentBaseTypes,
    selection: 'other',
    slot: 'jewellery',
    displayName: 'Excellent Crafting Bases',
    category: 'crafting',
    tieredTier: Tier.ARed,
    subtleTier: Tier.ARed,
    ruleId: 'jewellery-crafting-bases-excellent-base-types',
  },
  {
    equipmentType: EquipmentType.OtherJewelleryGoodBaseTypes,
    selection: 'other',
    slot: 'jewellery',
    displayName: 'Good Crafting Bases',
    category: 'crafting',
    tieredTier: Tier.BOrange,
    subtleTier: Tier.DWhite,
    ruleId: 'jewellery-crafting-bases-good-base-types',
  },
  {
    equipmentType: EquipmentType.OtherJewelleryExcellentSpecialBaseTypes,
    selection: 'other',
    slot: 'jewellery',
    displayName: 'Excellent Special',
    category: 'other',
    tieredTier: Tier.ARed,
    subtleTier: Tier.ARed,
    ruleId: 'jewellery-special-excellent',
  },
  {
    equipmentType: EquipmentType.OtherJewelleryGoodSpecialBaseTypes,
    selection: 'other',
    slot: 'jewellery',
    displayName: 'Good Special',
    category: 'other',
    tieredTier: Tier.BOrange,
    subtleTier: Tier.BOrange,
    ruleId: 'jewellery-special-good',
  },
  {
    equipmentType: EquipmentType.OtherJewelleryOtherSpecialBaseTypes,
    selection: 'other',
    slot: 'jewellery',
    displayName: 'Remaining Special',
    category: 'other',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'jewellery-special-other',
  },

  // Other Jewellery - Anointed Amulets
  {
    equipmentType: EquipmentType.OtherJewelleryAnointedAmulets,
    selection: 'other',
    slot: 'jewellery',
    displayName: 'Anointed Amulets',
    category: 'other',
    tieredTier: Tier.ARed,
    subtleTier: Tier.ARed,
    ruleId: 'jewellery-anointed-amulets',
  },

  // Other Jewellery - Identified
  {
    equipmentType: EquipmentType.OtherExcellentIdentifiedJewellery,
    selection: 'other',
    slot: 'jewellery',
    displayName: 'Excellent Identified',
    category: 'identified',
    tieredTier: Tier.SPurple,
    subtleTier: Tier.SPurple,
    ruleId: 'jewellery-identified-excellent',
  },
  {
    equipmentType: EquipmentType.OtherGoodIdentifiedJewellery,
    selection: 'other',
    slot: 'jewellery',
    displayName: 'Good Identified',
    category: 'identified',
    tieredTier: Tier.BOrange,
    subtleTier: Tier.BOrange,
    ruleId: 'jewellery-identified-good',
  },

  // Other Custom Items - Identified
  {
    equipmentType: EquipmentType.OtherExcellentIdentifiedCustomItems,
    selection: 'other',
    slot: 'gear',
    displayName: 'Excellent Custom Identified',
    category: 'identified',
    tieredTier: Tier.ARed,
    subtleTier: Tier.ARed,
    ruleId: 'gear-identified-custom-excellent',
  },
  {
    equipmentType: EquipmentType.OtherGoodIdentifiedCustomItems,
    selection: 'other',
    slot: 'gear',
    displayName: 'Good Custom Identified',
    category: 'identified',
    tieredTier: Tier.BOrange,
    subtleTier: Tier.BOrange,
    ruleId: 'gear-identified-custom-good',
  },

  // Favourite Jewels
  {
    equipmentType: EquipmentType.MyJewelsRare,
    selection: 'my',
    slot: 'jewel',
    displayName: 'Rare',
    category: 'regular',
    tieredTier: Tier.CYellow,
    subtleTier: Tier.CYellow,
    ruleId: 'jewels-my-rare',
  },
  {
    equipmentType: EquipmentType.MyJewelsMagic,
    selection: 'my',
    slot: 'jewel',
    displayName: 'Magic',
    category: 'regular',
    tieredTier: Tier.DWhite,
    subtleTier: Tier.EVisible,
    ruleId: 'jewels-my-magic',
  },

  // Other Jewels - Identified
  {
    equipmentType: EquipmentType.OtherExcellentIdentifiedJewels,
    selection: 'other',
    slot: 'jewel',
    displayName: 'Excellent Identified',
    category: 'identified',
    tieredTier: Tier.ARed,
    subtleTier: Tier.ARed,
    ruleId: 'jewels-identified-excellent',
  },
  {
    equipmentType: EquipmentType.OtherGoodIdentifiedJewels,
    selection: 'other',
    slot: 'jewel',
    displayName: 'Good Identified',
    category: 'identified',
    tieredTier: Tier.CYellow,
    subtleTier: Tier.CYellow,
    ruleId: 'jewels-identified-good',
  },

  // Favourite Flasks & Charms
  {
    equipmentType: EquipmentType.MyFlasksQuality,
    selection: 'my',
    slot: 'flask',
    displayName: 'Quality',
    category: 'crafting',
    tieredTier: Tier.DWhite,
    subtleTier: Tier.EVisible,
    ruleId: 'flasks-my-quality',
  },
  {
    equipmentType: EquipmentType.MyFlasksILevel,
    selection: 'my',
    slot: 'flask',
    displayName: 'High iLevel',
    category: 'crafting',
    tieredTier: Tier.DWhite,
    subtleTier: Tier.EVisible,
    ruleId: 'flasks-my-ilevel',
  },
  {
    equipmentType: EquipmentType.MyFlasksRegularNormal,
    selection: 'my',
    slot: 'flask',
    displayName: 'Regular, Normal',
    category: 'regular',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'flasks-my-regular-normal',
  },
  {
    equipmentType: EquipmentType.MyFlasksRegularMagic,
    selection: 'my',
    slot: 'flask',
    displayName: 'Regular, Magic',
    category: 'regular',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'flasks-my-regular-magic',
  },

  // Other Flasks & Charms
  {
    equipmentType: EquipmentType.OtherFlasksQuality,
    selection: 'other',
    slot: 'flask',
    displayName: 'Quality',
    category: 'salvaging',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'flasks-salvaging-quality',
  },
  {
    equipmentType: EquipmentType.OtherCharmsQuality,
    selection: 'other',
    slot: 'charm',
    displayName: 'Quality',
    category: 'salvaging',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'charms-salvaging-quality',
  },
  {
    equipmentType: EquipmentType.OtherCharmsILevel,
    selection: 'other',
    slot: 'charm',
    displayName: 'High iLevel',
    category: 'crafting',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    ruleId: 'charms-high-ilevel',
  },

  // Other Items
  {
    equipmentType: EquipmentType.ItemsTrialItems,
    selection: 'items',
    slot: 'other',
    displayName: 'Trial Items',
    category: 'other',
    tieredTier: Tier.DWhite,
    subtleTier: Tier.DWhite,
    hiddenWhenDisabled: true,
    ruleId: 'trial-relics',
  },
  {
    equipmentType: EquipmentType.NormalGoldStacks,
    selection: 'items',
    slot: 'other',
    displayName: 'Normal Gold Stacks',
    category: 'other',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    visibleWhenDisabled: true,
    ruleId: 'gold-normal-stacks',
  },
  {
    equipmentType: EquipmentType.LargeGoldStacks,
    selection: 'items',
    slot: 'other',
    displayName: 'Large Gold Stacks',
    category: 'other',
    tieredTier: Tier.DWhite,
    subtleTier: Tier.DWhite,
    visibleWhenDisabled: true,
    ruleId: 'gold-large-stacks',
  },
  {
    equipmentType: EquipmentType.HugeGoldStacks,
    selection: 'items',
    slot: 'other',
    displayName: 'Huge Gold Stacks',
    category: 'other',
    tieredTier: Tier.CYellow,
    subtleTier: Tier.CYellow,
    visibleWhenDisabled: true,
    ruleId: 'gold-huge-stacks',
  },
  {
    equipmentType: EquipmentType.NormalVerisiumStacks,
    selection: 'items',
    slot: 'other',
    displayName: 'Normal Verisium Stacks',
    category: 'other',
    tieredTier: Tier.EVisible,
    subtleTier: Tier.EVisible,
    visibleWhenDisabled: true,
    ruleId: 'verisium-normal-stacks',
  },
  {
    equipmentType: EquipmentType.LargeVerisiumStacks,
    selection: 'items',
    slot: 'other',
    displayName: 'Large Verisium Stacks',
    category: 'other',
    tieredTier: Tier.DWhite,
    subtleTier: Tier.DWhite,
    visibleWhenDisabled: true,
    ruleId: 'verisium-large-stacks',
  },
  {
    equipmentType: EquipmentType.HugeVerisiumStacks,
    selection: 'items',
    slot: 'other',
    displayName: 'Huge Verisium Stacks',
    category: 'other',
    tieredTier: Tier.CYellow,
    subtleTier: Tier.CYellow,
    visibleWhenDisabled: true,
    ruleId: 'verisium-huge-stacks',
  },

  // Other Items - POE2 - Waystones
  {
    equipmentType: EquipmentType.ItemsWaystonesRare,
    selection: 'maps',
    slot: 'other',
    displayName: 'Rare Waystones',
    category: 'other',
    tieredTier: Tier.BOrange,
    subtleTier: Tier.BOrange,
    hiddenWhenDisabled: true,
    ruleId: 'waystones-rare',
  },
  // {
  //   equipmentType: EquipmentType.ItemsWaystonesDelirium,
  //   selection: 'maps',
  //   slot: 'other',
  //   displayName: 'Delirium Waystones',
  //   category: 'other',
  //   tieredTier: Tier.BOrange,
  //   subtleTier: Tier.BOrange,
  //   hiddenWhenDisabled: true,
  //   ruleId: 'waystones-delirium',
  // },
  {
    equipmentType: EquipmentType.ItemsWaystonesOther,
    selection: 'maps',
    slot: 'other',
    displayName: 'Other Waystones',
    category: 'other',
    tieredTier: Tier.CYellow,
    subtleTier: Tier.CYellow,
    hiddenWhenDisabled: true,
    ruleId: 'waystones-other',
  },
];

